<template>
	<div>
		<div class="fadeinswt" v-if="aiDescShow">
			<div class="box">
				<p class="tit">【{{descFont.title}}】{{$t('pfgz')}}</p>
				<div class="child">
					<span v-html="descFont.desc"></span>
				</div>
				<div class="btn">
					<div @click="back">{{$t('zhidaole')}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import protal from "@/api/protal";
	import { Message } from 'element-ui';
	import { Loading } from 'element-ui';
	export default {
		name: 'aiSwtShow',
		props: ['descFont'],
		data() {
			return {
				
			}
		},
		computed: {
			aiDescShow() {
				return this.$store.state.aiDescShow;
			}
		},
		methods: {
			back() {
				this.$store.commit("showaiDESCShow", false);
			},
		},
	}
</script>

<style lang="less" scoped>

</style>


// WEBPACK FOOTER //
// src/components/ai_desc.vue